export enum DraftAction {
  DELETE = 'delete',
  ADD_TO_CART = 'addToCart',
  DELETE_COMPLETED = 'deleteCompleted',
}
